module.exports = __webpack_public_path__ + "img/giva-reports-min-1.e1a18a12.png";